import React from "react";
import { useTranslation } from "react-i18next";
import { formatDeltaPct, formatDeltaPp } from "./intentInsightsService";
import styles from "./intentInsights.module.scss";

export default function InsightsKpiRow({ data }) {
  const { t } = useTranslation();
  if (!data) return null;

  const cards = [
    {
      key: "conversations",
      label: t("sonic_prospect.intent_insights.kpi_conversations"),
      value: data.conversationCount?.toLocaleString(),
      sub: t("sonic_prospect.intent_insights.kpi_vs_week", {
        delta: formatDeltaPct(data.deltas?.conversationsPct),
      }),
      positive: (data.deltas?.conversationsPct ?? 0) >= 0,
    },
    {
      key: "visitors",
      label: t("sonic_prospect.intent_insights.kpi_visitors"),
      value: data.visitorCount?.toLocaleString(),
      sub: t("sonic_prospect.intent_insights.kpi_vs_week", {
        delta: formatDeltaPct(data.deltas?.visitorsPct),
      }),
      positive: (data.deltas?.visitorsPct ?? 0) >= 0,
    },
    {
      key: "leads",
      label: t("sonic_prospect.intent_insights.kpi_leads"),
      value: data.leadCount?.toLocaleString(),
      sub: t("sonic_prospect.intent_insights.kpi_vs_week", {
        delta: formatDeltaPct(data.deltas?.leadsPct),
      }),
      positive: (data.deltas?.leadsPct ?? 0) >= 0,
    },
    {
      key: "top_intent",
      label: t("sonic_prospect.intent_insights.kpi_top_intent"),
      value: data.topIntent?.label,
      sub: t("sonic_prospect.intent_insights.kpi_intent_share", {
        pct: data.topIntent?.pct,
      }),
      neutral: true,
    },
    {
      key: "sentiment",
      label: t("sonic_prospect.intent_insights.kpi_negative_sentiment"),
      value: `${data.negativeSentimentPct}%`,
      sub: t("sonic_prospect.intent_insights.kpi_vs_week_pp", {
        delta: formatDeltaPp(data.negativeSentimentDeltaPp),
      }),
      positive: (data.negativeSentimentDeltaPp ?? 0) <= 0,
    },
    {
      key: "confidence",
      label: t("sonic_prospect.intent_insights.kpi_confidence"),
      value: t(`sonic_prospect.intent_insights.confidence_${data.confidence || "low"}`),
      sub: t("sonic_prospect.intent_insights.kpi_confidence_based", {
        count: data.conversationCount,
      }),
      confidence: true,
    },
  ];

  return (
    <div className={styles.kpiRow}>
      {cards.map((card) => (
        <div key={card.key} className={styles.kpiCard}>
          <span className={styles.kpiLabel}>{card.label}</span>
          <span className={styles.kpiValue}>{card.value}</span>
          <span
            className={
              card.confidence
                ? styles.kpiSubConfidence
                : card.neutral
                  ? styles.kpiSubNeutral
                  : card.positive
                    ? styles.kpiSubUp
                    : styles.kpiSubDown
            }
          >
            {card.sub}
          </span>
        </div>
      ))}
    </div>
  );
}
